import {Box, Detection, Dim} from 'src/common/types/generics/ImageDetections'
import {boxToPoints} from 'src/common/utils/Internal'
import {resolveDetectionToPixels} from 'src/common/utils/demarcatedAreaCoordinates'

export function handlePointsDemarcatedArea(internalScale: number, detection: Detection, box: Box, typeDemarcatedArea?: string, imageDim?: Dim) {
  if (typeDemarcatedArea === 'face') {
    const resolved = imageDim ? resolveDetectionToPixels(detection, imageDim) : detection

    return [
      resolved.y * internalScale,
      resolved.x * internalScale,
      resolved.height * internalScale,
      resolved.x * internalScale,
      resolved.height * internalScale,
      resolved.width * internalScale,
      resolved.y * internalScale,
      resolved.width * internalScale,
      resolved.y * internalScale,
      resolved.width * internalScale,
    ]
  } else return boxToPoints(box)
}
